<template>
  <div class="notify-me-slide-in">
    <oie-base-action
      v-tooltip.top="!watchExists ? tStatic('articleWatchButtonTooltip') : tStatic('articleWatchedButtonTooltip')"
      :aria-label="!watchExists ? tStatic('articleWatchButtonTooltip') : tStatic('articleWatchedButtonTooltip')"
      size="large"
      theme="outlined"
      @click.stop="handleClick">
      <oie-base-icon :icon="watchExists ? 'notification-off' : 'notification'" size="s"></oie-base-icon>
    </oie-base-action>

    <oie-portal-wrapper :name="name">
      <template #title>
        <h3>
          {{ tStatic('articleWatchFormTitle') }}
        </h3>
      </template>
      <validation-observer ref="observer" v-slot="{ invalid }">
        <div class="notify-me-slide-in__content">
          <p>
            {{ tStatic('articleWatchFormDescription') }}
          </p>
          <validation-provider
            v-slot="{ errors }"
            rules="required|email"
            slim>
            <oie-base-input
              v-model="email"
              type="email"
              :label-text="tStatic('articleWatchEmailLabel')"
              :placeholder="tStatic('articleWatchEmailLabel')"
              :errors="errors"></oie-base-input>
          </validation-provider>
          <oie-base-checkbox
            v-if="!isLoggedIn"
            v-model="gdpr"
            :text="tStatic('articleWatchApproveTermsLabel')"
            is-for="notify-me-slide-in__form-checkbox"></oie-base-checkbox>
          <validation-provider
            v-slot="{ errors }"
            mode="passive"
            slim>
            <oie-recaptcha-v2
              v-if="!isLoggedIn"
              ref="recaptcha"
              v-model="recaptchaResponse"
              :errors="errors">
            </oie-recaptcha-v2>
          </validation-provider>
          <oie-action-wrapper>
            <template #left>
              <oie-base-action
                size="large"
                :disabled="invalid || (!isLoggedIn && !gdpr) || (!isLoggedIn && !recaptchaResponse)"
                @click="addArticleWatch">
                {{ tStatic('articleWatchSubmitButtonLabel') }}
              </oie-base-action>
              <oie-base-action
                size="large"
                theme="skeleton"
                @click="setActiveSlideIn(null)">
                {{ tStatic('genericClose') }}
              </oie-base-action>
            </template>
          </oie-action-wrapper>
        </div>
      </validation-observer>
    </oie-portal-wrapper>
  </div>
</template>

<script>
import httpService from '@/core/http-service'
import store from '@/store'
import { mapActions } from 'vuex'
import _ from 'lodash'

export default {
  props: {
    articleNumber: {
      type: [String, Number],
      default: ''
    },
    articleName: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    watchExists: false,
    email: '',
    gdpr: false,
    articleWatchId: '',
    recaptchaResponse: null
  }),
  computed: {
    name() {
      return _.uniqueId('notify-me-slide-in-')
    },
    isLoggedIn() {
      return !!store.getters.clientModel.user
    }
  },
  mounted() {
    if (store.getters.clientModel.user) {
      this.email = store.getters.clientModel.user.userName
      this.getWatchExists(this.email)
    }

    this.subscribe(`modal.hide.remove-article-watch.${this.articleNumber}`, () => {
      if (this.email) this.getWatchExists(this.email)
    })
  },
  methods: {
    ...mapActions('ui', ['setActiveSlideIn']),
    handleClick() {
      if (this.watchExists) {
        this.publish('modal.show.remove-article-watch', { id: this.articleWatchId, onHide: this.onModalHide })
      } else {
        this.setActiveSlideIn(this.name)
      }
    },
    onModalHide() {
      if (this.email !== '') this.getWatchExists(this.email)
    },
    getWatchExists(email) {
      httpService.get('article-watch/id', { email, articleNumber: this.articleNumber }).then(res => {
        this.watchExists = res.data.count > 0
        this.articleWatchId = res.data.items[0]
      }, () => { this.watchExists = false })
    },
    addArticleWatch() {
      const data = {
        email: this.email,
        articleNumber: this.articleNumber,
        articleName: this.articleName,
        market: store.getters.clientModel.currentMarket,
        language: store.getters.clientModel.currentLanguage,
        recaptchaResponse: this.recaptchaResponse
      }

      httpService.post('article-watch/add', data).then(() => {
        this.getWatchExists(this.email)
        this.setActiveSlideIn(null)
        if (!this.isLoggedIn) {
          this.$refs.recaptcha.reset()
        }
        this.gdpr = false
      })
    }
  }
}
</script>

<style lang="scss">
.notify-me-slide-in__content {
  display: flex;
  flex-direction: column;
  gap: measure(half);
}
</style>
